module.exports = __webpack_public_path__ + "static/media/Accident.dc6d9a32.svg";